import { animate, AnimationTriggerMetadata, keyframes, state, style, transition, trigger } from '@angular/animations';

import { ANIMATIONS } from './animations.data';

/**
 * @example
 * [@ngForAnimationFold]="item.open ? 'opened' : 'closed'"
 *
 */
export const foldDownUpAnimation: AnimationTriggerMetadata = trigger('ngForAnimationFold', [
    state('closed', style({
        height: 0,
        opacity: 0,
        marginTop: 0,
        pointerEvents: 'none'
    })),
    state('opened',   style({
        height: '*',
        opacity: 1,
        marginTop: '0.5rem',
        pointerEvents: 'inherit'
    })),
    transition('closed => opened', [
        animate(`${ANIMATIONS.speed.default} ${ANIMATIONS.bezierCurve.default}`,
            keyframes([
                style({height: 0, opacity: 0, marginTop: 0}),
                style({height: '*', opacity: 0.3}),
                style({height: '*', opacity: 1, marginTop: '0.5rem'})
            ])
        )
    ]),
    transition('opened => closed', [
        animate(`${ANIMATIONS.speed.leave} ${ANIMATIONS.bezierCurve.default}`,
            keyframes([
                style({height: '*', opacity: 1, marginTop: '0.5rem'}),
                style({height: '*', opacity: 0.3}),
                style({height: 0, opacity: 0, marginTop: 0})
            ])
        )
    ])
]);
